import React from 'react';
import PropTypes from 'prop-types';
import css from './HistoryFooter.css';

function HistoryFooter(props) {
  return (
    <div className={css['total']}>
      {props.totalMeetings} Total Meeting{props.totalMeetings === 1 ? '' : 's'}
    </div>
  );
}

HistoryFooter.propTypes = {  
  totalMeetings: PropTypes.number.isRequired,
};

export default HistoryFooter;
